import React, { useState, useRef, useEffect, useCallback } from 'react';
import { readEventDateTime, buildEventDateTime } from "../../../helpers/eventDateTime";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
import { useDropzone } from 'react-dropzone';
import { toast } from 'react-toastify';
import Masonry from 'react-masonry-css';
import ImageModal from "../../../components/ImageModal/ImageModal";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import API_UTIL from '../../../services/AuthIntereptor';
import AppBar from '../../../components/AppBar/AppBar';
import Footer from '../../../components/Footer/Footer';
import MergeDuplicateUsers from '../../../pages/Pro/ProShare/MergeHandler/MergeDuplicateUsers';
import LoadingSpinner from '../../../components/Loader/LoadingSpinner';
import LabelAndInput from '../../../components/molecules/LabelAndInput/LabelAndInput';
import { generateFlashbackReport } from '../../../helpers/generateFlashbackReport';
import {
  Icons,
  Button,
  Pill,
  UnderlineTab,
  ModalShell,
  ModalHeader,
} from '../../../components/ui';

/* PhotoCard — native lazy loading + skeleton-to-image reveal, no extra library */
const PhotoCard = ({ imageData, index, onImageClick, onToggleFav }) => {
  const [loaded, setLoaded] = useState(false);
  return (
    <div className="relative rounded-xl overflow-hidden bg-gray-100 border border-gray-200 group cursor-pointer aspect-[4/3]">
      {/* Skeleton while loading — fills the whole fixed-size cell */}
      {!loaded && (
        <div className="absolute inset-0 animate-pulse bg-gray-200" />
      )}
      <img
        src={imageData.thumbnail}
        alt={`photo ${index + 1}`}
        loading="lazy"
        decoding="async"
        onLoad={() => setLoaded(true)}
        onClick={() => onImageClick(imageData, index)}
        className={`w-full h-full object-cover transition-all duration-300 group-hover:scale-105 ${loaded ? 'opacity-100' : 'opacity-0'}`}
      />
      <button
        onClick={(e) => { e.stopPropagation(); onToggleFav(index); }}
        className="absolute bottom-2 right-2 w-8 h-8 grid place-items-center bg-white/95 backdrop-blur rounded-full border border-gray-200 shadow-soft opacity-0 group-hover:opacity-100 transition"
        aria-label={imageData.isFavourites ? 'Unfavourite' : 'Favourite'}
      >
        <Icons.Heart filled={imageData.isFavourites} className="w-4 h-4" />
      </button>
    </div>
  );
};

const EventDetails = () => {
  const { eventName } = useParams();
  const location = useLocation();
  const [event, setEvent] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [isCollabModalOpen, setIsCollabModalOpen] = useState(false);
  const [eventData, setEventData] = useState(null);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [isPeopleLoading, setIsPeopleLoading] = useState(false);
  const [eventDetails, setEventDetails] = useState(null);
  const [images, setImages] = useState([]);
  const [continuationToken, setContinuationToken] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const [totalPhotoCount, setTotalPhotoCount] = useState(null);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [uploadStatus, setUploadStatus] = useState('');
  const [uploading, setUploading] = useState(false);
  const [fileCount, setFileCount] = useState(0);
  const [totalUploadedBytes, setTotalUploadedBytes] = useState(0);
  const [uploadedFilesCount, setUploadedFilesCount] = useState(0);
  const [isUploadFilesModelOpen, setUploadFilesModeOpen] = useState(false);
  const [files, setFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [userThumbnails, setUserThumbnails] = useState([]);
  const [mergeMode, setMergeMode] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [activeTab, setActiveTab] = useState('gallery');
  const [userDetails, setUserDetails] = useState(null);
  const [requiredCoins, setRequiredCoins] = useState(0);
  const [canUpload, setCanUpload] = useState(false);
  const [showMergePopup, setShowMergePopup] = useState(false);
  const [showMergeDuplicateUsers, setShowMergeDuplicateUsers] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const userPhoneNumber = localStorage.userPhoneNumber;
  const [isImageProcessingDone, setIsImageProcessingDone] = useState(true);
  const [isSendModalOpen, setIsSendModalOpen] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [selectedMainUser, setSelectedMainUser] = useState(null);
  const [selectedDuplicateUsers, setSelectedDuplicateUsers] = useState([]);
  const [overallProgress, setOverallProgress] = useState(0);
  const [uploadFilesModalStatus, setUploadFilesModalStatus] = useState('');
  const [isDownloadingAlbum, setIsDownloadingAlbum] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [isWarningModalOpen, setIsWarningModalOpen] = useState(false);
  const [isUploadFilesFailed, setIsUploadFilesFailed] = useState(false);
  const [isCoinsDedcuted, setIsCoinsDeducted] = useState(false);
  const [mergeMessage, setMergeMessage] = useState("");
  const isDataFetched = useRef(false);
  const [clickedImg, setClickedImg] = useState(null);
  const [clickedImgIndex, setClickedImgIndex] = useState(null);
  const [clickedImgFavourite, setClickedImgFavourite] = useState(null);
  const [clickedUrl, setClickedUrl] = useState(null);
  const [modalImages, setModalImages] = useState([]);
  const [rewardPoints, setRewardPoints] = useState();
  const [clientDetails, setClientDetails] = useState([]);
  const [showRewardPointsPopUp, setShowRewardPointsPopUp] = useState(null);
  const [isGalleryLoading, setIsGalleryLoading] = useState(false);
  const [watermarkPreview, setWatermarkPreview] = useState(null);
  const [currentWatermark, setCurrentWatermark] = useState(null);
  const [isClaimPopupOpen, setIsClaimPopupOpen] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);
  const [userCategoryTab, setUserCategoryTab] = useState('registered');
  const [showCopied, setShowCopied] = useState(false);
  const [isImageLoading, setIsImageLoading] = useState(true);
  const [registrationCount, setRegistrationCount] = useState(0);
  const [isCountLoading, setIsCountLoading] = useState(true);
  const [isPanelExpanded, setIsPanelExpanded] = useState(false);
  const navigate = useNavigate();
  const qrRef = useRef();
  const loader = useRef(null);
  const [eventImage, setEventImage] = useState('');


  const onLoad = () => {
    setIsImageLoading(false);
    const lazySpan = document.querySelector(".lazyImage");
    lazySpan && lazySpan.classList.add("visible");
  };


  useEffect(() => {
    if (event) fetchEventFavouriteImages();
  }, [event]);


  useEffect(() => {
    fetchEventData(eventName);
    fetchUserDetails();
  }, [eventName]);

  const fetchEventData = async (eventName) => {
    setIsPageLoading(true);
    try {
      const response = await API_UTIL.get(`/getEventDetails/${eventName}`);
      setEvent(response.data);
      setEventImage(response.data.event_image);

      if (response.data.watermark_url) {
        setCurrentWatermark(response.data.watermark_url);
      }

      // Date and time are independent and both optional; older rows may hold a
      // half-built value such as "2026-10-28T:00", so read whichever parts are usable.
      const { date: eventDate, time: eventTime } = readEventDateTime(response.data);

      setEventData({
        eventName: response.data.event_name,
        eventDate: eventDate,
        eventTime: eventTime,
        invitationNote: response.data.invitation_note,
        eventLocation: response.data.event_location,
        folder_name: response.data.folder_name,
        watermarkImage: null
      });

      setIsImageProcessingDone(response.data.uploaded_files === response.data.files_indexed);
    } catch (error) {
      console.error("Error fetching event data:", error);
    } finally {
      setIsPageLoading(false);
    }
  };

  const downloadEventAlbum = () => {
    setIsDownloadingAlbum(true);

    // Construct the download URL with route parameters
    const downloadUrl = `${process.env.REACT_APP_SERVER_IP}/downloadEventAlbum/${encodeURIComponent(event.folder_name)}/${encodeURIComponent(formatEventName(event.event_name))}`;

    fetch(downloadUrl, { method: 'HEAD' })
      .then(response => {
        if (response.status === 404) {
          toast.error('No images found in this event to download.');
          setIsDownloadingAlbum(false);
          return;
        }

        if (!response.ok) {
          toast.error('Failed to start download. Please try again.');
          setIsDownloadingAlbum(false);
          return;
        }

        // If successful, trigger the actual download
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', `${formatEventName(event.event_name)}_Album.zip`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        toast.success('Album download started! Check your downloads.');

        // Reset the button state after a delay
        setTimeout(() => {
          setIsDownloadingAlbum(false);
        }, 10000);
      })
      .catch(error => {
        console.error('Error checking download:', error);
        toast.error('Failed to start download. Please try again.');
        setIsDownloadingAlbum(false);
      });
  };




  const fetchEventFavouriteImages = async () => {
    setIsGalleryLoading(true);
    try {
      const eventOwners = await API_UTIL.get(`/getEventOwners/${event.event_id}`);
      const uniqueFavoriteImages = new Map();

      for (const owner of eventOwners.data.owners) {
        const response = await API_UTIL.get(`/getOwnerFavImages/${eventOwners.data.folder_name}/${owner}`);
        if (response.status === 200) {
          response.data.forEach((obj) => {
            const originalUrl = obj.s3_url;
            const thumbnailUrl = originalUrl.replace('/Deliverables/', '/Deliverables/thumbnails/');
            if (!uniqueFavoriteImages.has(originalUrl)) {
              uniqueFavoriteImages.set(originalUrl, {
                original: originalUrl,
                thumbnail: thumbnailUrl,
                isFavourites: true,
              });
            }
          });
        }
      }

      const allUniqueFavoriteImages = Array.from(uniqueFavoriteImages.values());
      setImages((prevImages) => {
        const favImageUrls = new Set(allUniqueFavoriteImages.map((image) => image.original));
        const nonFavImages = prevImages.filter((image) => !favImageUrls.has(image.original));
        return [...allUniqueFavoriteImages, ...nonFavImages];
      });
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsGalleryLoading(false);
    }
  };


  const handleWatermarkChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setEventData({ ...eventData, watermarkImage: file });
      const reader = new FileReader();
      reader.onload = (e) => setWatermarkPreview(e.target.result);
      reader.readAsDataURL(file);
    }
  };

  const fetchUserDetails = async () => {
    if (isLoading || !hasMore) return;

    setIsLoading(true)
    try {
      const response = await API_UTIL.get(`/getUserDetails/${userPhoneNumber}`);
      if (response.status === 200) {
        setUserDetails(response.data);
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const closeImageModal = () => {
    setSelectedImage(null);
  };

  const fetchImages = useCallback(async () => {
    if (!event || !hasMore || isGalleryLoading) return;

    setIsGalleryLoading(true);
    try {
      const response = await API_UTIL.get(`/getEventImages/${event.folder_name}?continuationToken=${encodeURIComponent(continuationToken || '')}`);

      if (response.status === 200) {
        const { images: s3Urls, lastEvaluatedKey, totalCount } = response.data;

        // Only the first page carries the full event count
        if (typeof totalCount === 'number') setTotalPhotoCount(totalCount);

        const formattedImages = s3Urls.map((url) => ({
          original: url,
          thumbnail: url,
          isFavourites: false,
        }));

        setImages((prevImages) => {
          const existingUrls = new Set(prevImages.map((image) => image.original));
          const uniqueImages = formattedImages.filter((image) => !existingUrls.has(image.original));
          return [...prevImages, ...uniqueImages];
        });
        setContinuationToken(lastEvaluatedKey);
        setHasMore(Boolean(lastEvaluatedKey));
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching images:", error);
      setHasMore(false);
    } finally {
      setIsGalleryLoading(false);
    }
  }, [continuationToken, hasMore, isGalleryLoading, event]);

  useEffect(() => {
    if (event && activeTab === 'gallery' && images.length === 0) {
      fetchImages();
    }
  }, [event, activeTab, images.length, fetchImages]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasMore && !isGalleryLoading) {
          fetchImages();
        }
      },
      { threshold: 0.5 }
    );

    if (loader.current) {
      observer.observe(loader.current);
    }

    return () => {
      if (loader.current) {
        observer.unobserve(loader.current);
      }
    };
  }, [fetchImages, hasMore, isGalleryLoading]);

  const fetchUserThumbnails = async () => {
    setIsPeopleLoading(true);
    try {
      const response = await API_UTIL.get(`/userThumbnailsByEventId/${event.event_id}`);
      if (response.status === 200) {
        setUserThumbnails(response.data);
      } else {
        throw new Error("Failed to fetch user thumbnails");
      }
    } catch (error) {
      console.error("Error fetching user thumbnails:", error);
    } finally {
      setIsPeopleLoading(false);
    }
  };

  useEffect(() => {
    if (event && activeTab === 'people') {
      fetchUserThumbnails();
    }
  }, [event, activeTab]);

  const handleEditClick = () => setEditMode(true);
  const handleCancelEdit = () => setEditMode(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEventData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  const fetchRegistrationCount = async () => {
    if (!event?.folder_name) return;

    try {
      setIsCountLoading(true);
      // Double encode to handle special characters
      const encodedEventName = encodeURIComponent(event.folder_name);
      console.log('Fetching count for:', {
        original: event.folder_name,
        encoded: encodedEventName
      });

      const response = await API_UTIL.get(`/getRegistrationCount/${encodedEventName}`);

      if (response.status === 200) {
        setRegistrationCount(response.data.count);
      }
    } catch (error) {
      console.error("Error fetching registration count:", {
        error,
        eventName: event.event_name
      });
    } finally {
      setIsCountLoading(false);
    }
  };

  // Set up polling
  useEffect(() => {
    if (event?.folder_name) {
      // Initial fetch
      fetchRegistrationCount();

      // Set up polling interval (every 30 seconds)
      const intervalId = setInterval(fetchRegistrationCount, 30000);

      // Clean up interval on unmount
      return () => clearInterval(intervalId);
    }
  }, [event?.event_name]);


  const encodeEventUrl = (folderName) => {
    // First, encode all special characters
    const encoded = encodeURIComponent(folderName)
      // Handle specific characters that need custom encoding
      .replace(/'/g, '%27')
      .replace(/\(/g, '%28')
      .replace(/\)/g, '%29')
      .replace(/!/g, '%21')
      .replace(/\*/g, '%2A')
      .replace(/%C2%AE/g, '®'); // Convert back registered trademark symbol

    return encoded;
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      const formDataToSend = new FormData();
      formDataToSend.append('event_name', eventData.eventName);
      formDataToSend.append('event_date', buildEventDateTime(eventData.eventDate, eventData.eventTime));
      formDataToSend.append('invitation_note', eventData.invitationNote);
      formDataToSend.append('event_location', eventData.eventLocation);

      // Add watermark if selected
      if (eventData.watermarkImage) {
        formDataToSend.append('watermarkImage', eventData.watermarkImage);
      }

      const response = await API_UTIL.put(`/updateEvent/${event.event_id}`, formDataToSend, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.status === 200) {
        setEditMode(false);
        fetchEventData(eventName);
        toast.success('Event updated successfully');

        // Clear watermark preview
        setWatermarkPreview(null);
        setEventData({ ...eventData, watermarkImage: null });


        if (eventData.watermarkImage && response.data.watermark_url) {
          setCurrentWatermark(response.data.watermark_url);
        }
      }
    } catch (error) {
      console.error('Error updating event:', error);
      toast.error('Failed to update the event. Please try again.');
    }
  };

  const downloadQRCode = () => {
    const svg = qrRef.current.querySelector('svg');
    if (svg) {
      const svgData = new XMLSerializer().serializeToString(svg);
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();
      const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
      const url = URL.createObjectURL(svgBlob);
      img.onload = () => {
        canvas.width = img.width || 200;
        canvas.height = img.height || 200;
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0);
        URL.revokeObjectURL(url);
        const pngUrl = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
        let downloadLink = document.createElement('a');
        downloadLink.href = pngUrl;
        downloadLink.download = `${event.event_name}_QR.png`;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      };
      img.src = url;
    } else {
      console.error('QR Code svg not found');
    }
  };

  const handleCollabClick = () => {
    setIsCollabModalOpen(true);
  };

  const downloadCollabQRCode = () => {
    const svg = document.querySelector('#collab-qr-canvas svg');
    if (svg) {
      const svgData = new XMLSerializer().serializeToString(svg);
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();
      const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
      const url = URL.createObjectURL(svgBlob);
      img.onload = () => {
        canvas.width = img.width || 180;
        canvas.height = img.height || 180;
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0);
        URL.revokeObjectURL(url);
        const pngUrl = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
        let downloadLink = document.createElement('a');
        downloadLink.href = pngUrl;
        downloadLink.download = `${formatEventName(event?.event_name)}_Collaboration_QR.png`;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        toast.success('QR Code downloaded successfully!');
      };
      img.src = url;
    } else {
      toast.error('QR Code not found');
    }
  };

  const copyCollabLinkToClipboard = () => {
    const collabLink = `https://imageshield.ai/collab/${event.event_id}`;
    navigator.clipboard.writeText(collabLink).then(() => {
      toast.success('Collaboration link copied to clipboard!');
    }).catch((err) => {
      console.error('Failed to copy: ', err);
      toast.error('Failed to copy link');
    });
  };

  const shareCollabOnWhatsApp = () => {
    const collabLink = `https://imageshield.ai/collab/${event.event_id}`;
    const message = `Join the collaboration for the event: ${formatEventName(event?.event_name)}. Collaborate using the following link: ${collabLink}`;
    const url = `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  const UsershareOnWhatsApp = (item) => {
    const userId = item.user_id;
    const count = item.count;
    const text = `*Greetings*,\nWe have discovered your *${count}* images captured during the event *"${eventDetails?.event_name}"*.\nKindly proceed to the provided URL to access and view your photographs:\nhttps://imageshield.ai/photosV1/${eventDetails?.folder_name}/${userId}\n\nCheers,\n*ImageShield*`;
    const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(text)}`;
    window.open(whatsappUrl, "_blank");
  };

  const onDrop = useCallback((acceptedFiles) => {
    const totalFiles = acceptedFiles.length;
    if (totalFiles > 500) {
      setFileCount(totalFiles);
      setUploadStatus(`You have selected ${totalFiles} files. You can upload a maximum of 500 files at a time.`);
      setUploading(false);
    } else {
      setFiles(acceptedFiles);
      setFileCount(totalFiles);
      setUploadProgress({});
      setUploadStatus('');
      setUploading(false);
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  const uploadFiles = async () => {
    if (files.length === 0) {
      setUploadStatus('Please select files to upload');
      return;
    }

    setUploading(true);
    setUploadFilesModalStatus('Uploading files...');
    setIsUploadFilesFailed(false);
    setOverallProgress(0); // Start at 0% progress

    const MAX_CONCURRENT_UPLOADS = 3;
    const MAX_RETRIES = 3;
    let index = 0;
    const totalFiles = files.length;

    let uploadingFilesCount = 0;

    // Use React state to safely track the total uploaded bytes

    const uploadFile = async (file) => {
      const formData = new FormData();

      formData.append('files', file);

      let attempts = 0;
      let delayTime = 1000; // Start with 1 second delay fpr retry

      while (attempts < MAX_RETRIES) {
        try {
          const response = await API_UTIL.post(
            `/uploadFiles/${event.event_name}/${userPhoneNumber}/${event.folder_name}`,
            formData,
            {
              headers: { 'Content-Type': 'multipart/form-data' },
            }
          );
          // Increment the completed files count and update overall progress after each file upload completes
          uploadingFilesCount += 1;
          const overallProgress = (uploadingFilesCount / totalFiles) * 100;
          setOverallProgress(Math.ceil(overallProgress)); // Update only once per file

          return response.data;
        } catch (error) {
          attempts += 1;
          if (error.response && error.response.status === 429) {
            console.error(`Error uploading file ${file.name}, attempt ${attempts}: Too many requests. Retrying after ${delayTime / 1000} seconds.`);
            await delay(delayTime);
            delayTime *= 2; // Exponential backoff
          } else {
            console.error(`Error uploading file ${file.name}, attempt ${attempts}:`, error);
          }
          if (attempts === MAX_RETRIES) {
            throw error;
          }
        }
      }
    };

    const handleUploads = async () => {
      while (uploadingFilesCount < files.length) {
        const uploadPromises = []; // Initialize a new array for each batch
        for (let i = 0; i < MAX_CONCURRENT_UPLOADS && uploadingFilesCount + i < files.length; i++) {
          uploadPromises.push(uploadFile(files[uploadingFilesCount + i]));
        }
        await Promise.allSettled(uploadPromises);
      }
    };

    try {
      await handleUploads();

      // After all files are uploaded successfully, update the uploaded files count
      const newUploadedFilesCount = uploadingFilesCount + uploadedFilesCount; // Only use uploadingFilesCount as it tracks successful uploads
      setUploadedFilesCount(newUploadedFilesCount);

      try {
        const response = await API_UTIL.put(`/updateEvent/${event.event_id}`, {
          event_name: eventData.eventName,
          event_date: buildEventDateTime(eventData.eventDate, eventData.eventTime),
          invitation_note: eventData.invitationNote,
          event_location: eventData.eventLocation,
          uploaded_files: newUploadedFilesCount,
        });

        if (response.status === 200) {
          toast.success('Files uploaded successfully');
        }
      } catch (error) {
        console.error('Error updating event with new file count:', error);
        toast.error('Failed to update the event with new file count. Please try again.');
      }

      setUploadStatus('Upload completed successfully');
      setFiles([]);

      // Auto-refresh the gallery so newly uploaded photos appear without a page reload.
      // Clearing the list + resetting pagination re-triggers the fetch effect (images.length === 0).
      setImages([]);
      setContinuationToken(null);
      setHasMore(true);
    } catch (error) {
      console.error('Upload failed:', error);
      setUploadStatus('Upload failed. Please try again.');
    } finally {
      setUploading(false);
      setOverallProgress(100); // Ensure progress bar is set to 100% on completion
      setFileCount(0);
      // setUploadFilesModeOpen(false);
      closeUploadFilesModal();
    }
  };

  const handleClick = (item) => {
    if (mergeMode) {
      handleThumbnailClick(item);
    } else {
      saveShareDetails(item);
      UsershareOnWhatsApp(item);
    }
  };

  const handleMergeClick = () => {
    if (!isImageProcessingDone) {
      setIsWarningModalOpen(true); // Show warning if images are still processing
    } else {
      setShowMergeDuplicateUsers(true);
      setMergeMode(true);
      setSelectedMainUser(null);
      setSelectedDuplicateUsers([]);
    }
  };

  const handleCancelManageUsers = () => {
    setMergeMode(false);
    setShowMergePopup(false);
    setSelectedUsers([]);
    setMergeMessage("");
    setShowMergeDuplicateUsers(false);
  };

  const handleThumbnailClick = (user) => {
    if (!mergeMode) return;

    setSelectedUsers((prev) => {
      const isSelected = prev.some((u) => u.user_id === user.user_id);
      if (isSelected) {
        return prev.filter((u) => u.user_id !== user.user_id);
      } else if (prev.length < 2) {
        const newSelected = [...prev, user];
        if (newSelected.length === 2) {
          setShowMergePopup(true);
        }
        return newSelected;
      }
      return prev;
    });
  };

  const saveShareDetails = async (item) => {
    try {
      const user = userPhoneNumber;
      const response = await API_UTIL.post(`/saveProShareDetails`, {
        user: user,
        sharedUser: item.user_id,
        event_id: event.event_id,
      });
      if (response.status === 200) {
      } else {
        throw new Error("Failed to save share info");
      }
    } catch (error) {
      console.error("Error saving share details:", error);
    }
  };

  useEffect(() => {
    const fetchEventDetailsInterval = () => {
      if (event && event.event_id) {
        fetchEventDetails(event.event_id);
      }
    };

    fetchEventDetailsInterval(); // Fetch event details initially

    const interval = setInterval(fetchEventDetailsInterval, 30000); // Fetch event details every 30 seconds

    return () => clearInterval(interval); // Clean up interval on component unmount
  }, [event?.event_id]); // Dependency on event.event_id

  useEffect(() => {
    if (isDataFetched.current) return;
    fetchThumbnails();
    isDataFetched.current = true;
  }, []);

  const fetchThumbnails = async () => {
    if (!event) return;
    if (userThumbnails.length === 0) setIsLoading(true);

    try {
      const response = await API_UTIL.get(`/userThumbnailsByEventId/${event.event_id}`);
      if (response.status === 200) {
        setUserThumbnails(response.data);
        fetchClientDetails();
      } else {
        throw new Error("Failed to fetch user thumbnails");
      }
    } catch (error) {
      console.error("Error fetching user thumbnails:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchClientDetails = async () => {
    if (userThumbnails.length === 0) setIsLoading(true);

    try {
      const response = await API_UTIL.get(`/userThumbnailsByEventId/${event.event_id}`);
      if (response.status === 200) {
        setClientDetails(response.data);
        fetchUserDetails();
      } else {
        throw new Error("Failed to fetch client Details");
      }
    } catch (error) {
      console.error("Error fetching user thumbnails:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleImageClick = (imageData, index, imageList = images) => {
    console.log("Image clicked");
    setModalImages(imageList);
    setClickedImg(imageData.thumbnail);
    setClickedImgIndex(index);
    setClickedImgFavourite(imageData.isFavourites);
    setClickedUrl(imageData.original);
    window.history.pushState({ id: 1 }, "", `${window.location.pathname}?image=${imageData.original.split('/').pop()}`);
  };

  const openUploadFilesModal = () => {
    setUploadFilesModeOpen(true);
  };

  const closeUploadFilesModal = () => {
    setUploadFilesModeOpen(false);
    setFiles([]);
    setUploadProgress({});
    setUploadStatus('');
    setUploading(false);
    setFileCount(0);
  };

  // const handleCloseModal = () => {
  //   setClickedImg(null);
  //   setClickedImgIndex(null);
  //   setClickedImgFavourite(null);
  //   setClickedUrl(null);
  //   window.history.back();
  // };

  const handleBackButton = () => {
    setClickedImg(null);
  };

  useEffect(() => {
    window.addEventListener("popstate", handleBackButton);
    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, []);

  const handleFavourite = async (index, imageUrl, isFav) => {
    const imageIndex = images.findIndex((image) => image.original === imageUrl);

    if (imageIndex !== -1) {
      setImages((currentImages) =>
        currentImages.map((image) =>
          image.original === imageUrl ? { ...image, isFavourites: isFav } : image
        )
      );
    }

    setModalImages((currentImages) =>
      currentImages.map((image) =>
        image.original === imageUrl ? { ...image, isFavourites: isFav } : image
      )
    );

    await API_UTIL.post("/setFavouritesNew", {
      imageUrl,
      userId: userDetails.user_id,
      isFav,
    });
  };

  const toggleFavourite = (index) => {
    if (!images[index]) return;
    const isFav = !images[index].isFavourites;
    handleFavourite(index, images[index].original, isFav);
  };


  const formatEventName = (name) => {
    if (!name) return '';
    let event = name.replace(/_/g, ' ');
    if (userDetails && userDetails.user_name) {
      event = event.replace(userDetails.user_name, '');
    }
    return event.trim();
  };

  function getFormattedDate(datetime) {
    console.log("inside format");
    console.log(datetime);
    const date = new Date(datetime);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  function getFormattedTime(datetime) {
    const date = new Date(datetime);
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? String(hours).padStart(2, '0') : '12';
    return `${hours}:${minutes} ${ampm}`;
  }


  const fetchEventDetails = async () => {
    try {
      const response = await API_UTIL.get(`/getEventDetails/${event.event_id}`);
      if (response.status === 200) {
        setEventDetails(response.data); // Set event details in state
        setUploadedFilesCount(response.data.uploaded_files || 0);
        if (response.data.uploaded_files === response.data.files_indexed) {
          if (isImageProcessingDone === false)
            fetchThumbnails()
          setIsImageProcessingDone(true);
        }
        else {
          setIsImageProcessingDone(false);

        }
      } else {
        throw new Error("Failed to fetch event details");
      }
    } catch (error) {
      console.error("Error fetching event details:", error);
    }
  };


  const handleMerge = async (reason) => {
    if (!event) return;
    try {
      const user_phone_number = localStorage.getItem("userPhoneNumber");
      const response = await API_UTIL.post("/mergeUsers", {
        userIds: selectedUsers.map((u) => u.user_id),
        reason: reason,
        eventId: event.event_id,
        user_phone_number: user_phone_number,
      });

      if (response.data.success) {
        await fetchThumbnails();
      }
      return response.data;
    } catch (error) {
      console.error("Error merging users:", error);
      return { success: false, message: "Error merging users. Please try again." };
    }
  };

  const copyLinkToClipboard = () => {
    const encodedFolderName = encodeEventUrl(event.folder_name);
    const link = `https://imageshield.ai/login/${event.folder_name}`;
    navigator.clipboard.writeText(link).then(() => {
      setShowCopied(true);
      setTimeout(() => {
        setShowCopied(false);
      }, 2000);
    }).catch((err) => {
      console.error('Failed to copy: ', err);
    });
  };

  const handleEventImageUpdate = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append('eventImage', file);
      formData.append('eventId', event.event_id); // Assuming you have eventId in your state
      formData.append('eventName', formData.org_name); // Use the correct form data field if it's named differently
      formData.append('clientName', event.client_name); // Assuming clientName is in your state or form data

      try {
        const response = await API_UTIL.post('/updateEventImage', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        if (response.data && response.data.imageUrl) {
          const formattedUrl = encodeURIWithPlus(response.data.imageUrl);
          console.log(`formattedUrl:`, formattedUrl);
          setEvent((prevData) => ({
            ...prevData,
            'event_image': formattedUrl // Replace 'new value' with the actual value you want to set
          }));
          setEventImage(formattedUrl);

        }
      } catch (error) {
        console.error('Error updating event image:', error);
      }
    }
  };
  const encodeURIWithPlus = (uri) => {
    return uri.replace(/ /g, '+');
  };

  const sendTwilioMsg = async () => {
    try {
      const userIdMappingResponse = await API_UTIL.post("/generateUserIdsForExistingUsers", {
        eventName: eventDetails?.folder_name, event: eventDetails?.event_name,
      });
      if (userIdMappingResponse.status === 200) {
        const sendFlashbacksResponse = await API_UTIL.post("/send-flashbacks", {
          eventName: eventDetails?.folder_name,
        });

        if (sendFlashbacksResponse.status === 200) {
          toast.success("Photos sent successfully!");
          // Build the delivery report PDF in the browser and download it automatically.
          const report = sendFlashbacksResponse.data?.report;
          if (report) {
            try {
              generateFlashbackReport(report);
            } catch (pdfError) {
              console.error("Error generating report PDF:", pdfError);
              toast.error("Photos sent, but the report PDF could not be generated");
            }
          }
        } else {
          throw new Error("Failed to send photos.");
        }
      } else {
        throw new Error("Failed to send photos.");
      }
    } catch (error) {
      console.error("Error Publishing Images", error);
      toast.error("Failed to Publish Images");
    }
  };


  const removeWatermark = async () => {
    try {
      const response = await API_UTIL.delete(`/removeWatermark/${event.event_id}`);
      if (response.status === 200) {
        setCurrentWatermark(null);
        toast.success('Watermark removed successfully');
      }
    } catch (error) {
      console.error('Error removing watermark:', error);
      toast.error('Failed to remove watermark');
    }
  };

  const handleSendPhotos = async () => {
    if (!isImageProcessingDone) {
      setIsWarningModalOpen(true); // Show warning if images are still processing
    } else {
      setIsSending(true);
      setIsSendModalOpen(true);
      try {
        await sendTwilioMsg();
      } finally {
        setIsSending(false);
      }
    }
  };
  const closeWarningModal = () => {
    setIsWarningModalOpen(false);
  };
  const closeClaimPopup = () => {
    setIsClaimPopupOpen(false);
  };

  const registeredUsers = userThumbnails.filter((thumbnail) => thumbnail.is_registered);
  const unregisteredUsers = userThumbnails.filter((thumbnail) => !thumbnail.is_registered);


  if (isPageLoading) {
    return <LoadingSpinner />;
  }

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!event) {
    return <div>No event data available. Please try again later.</div>;
  }

  const loginLink = `https://imageshield.ai/login/${event.folder_name}`;
  const collabLink = `https://imageshield.ai/collab/${event.event_id}`;
  const favouriteImages = images.filter((image) => image.isFavourites);
  const viewerImages = modalImages.length > 0 ? modalImages : images;

  return (
    <div className="min-h-screen flex flex-col bg-white text-slate-900">
      <AppBar />

      <div className="flex-1 fade-in max-w-[1400px] mx-auto w-full px-4 sm:px-6 py-6">
        {/* Breadcrumb */}
        <div className="mb-4 flex items-center gap-2 text-sm">
          <button
            onClick={() => navigate(location.state?.returnTo || '/event?tab=my')}
            className="inline-flex items-center gap-1 text-slate-500 hover:text-slate-900"
          >
            <Icons.ChevronLeft className="w-4 h-4" />
            Events
          </button>
          <Icons.Chevron className="w-3.5 h-3.5 text-slate-300" />
          <span className="font-medium text-slate-900 truncate max-w-[60ch]">
            {formatEventName(event?.event_name)}
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          {/* Sidebar */}
          <aside className="lg:col-span-1">
            <div className="lg:sticky lg:top-20 space-y-4">
              <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-card">
                <div className="relative aspect-[5/3] bg-gray-50">
                  {event.event_image ? (
                    <img src={event.event_image} alt="Event" className="w-full h-full object-cover" />
                  ) : (
                    <div className="w-full h-full grid place-items-center text-slate-300">
                      <Icons.Image className="w-10 h-10" />
                    </div>
                  )}
                  <button
                    onClick={handleEditClick}
                    className="absolute top-2 right-2 w-9 h-9 grid place-items-center bg-white/95 backdrop-blur border border-gray-200 hover:border-brand-200 hover:text-brand-600 text-slate-600 rounded-lg shadow-soft"
                    aria-label="Edit event"
                    title="Edit event"
                  >
                    <Icons.Edit className="w-4 h-4" />
                  </button>
                </div>
                <div className="p-5">
                  <h2 className="font-bold text-slate-900 text-lg leading-tight">
                    {formatEventName(event?.event_name)}
                  </h2>

                  <div className="mt-5 pt-5 border-t border-gray-100">
                    <div className="flex items-center justify-between mb-3">
                      <span className="text-xs font-semibold uppercase tracking-wider text-slate-500">Event QR</span>
                      <span className="font-mono text-[10px] text-slate-400">SCAN TO JOIN</span>
                    </div>
                    <div ref={qrRef} className="bg-gray-50 border border-gray-200 rounded-xl p-3 grid place-items-center">
                      <QRCodeSVG value={loginLink} size={200} />
                    </div>
                    <div className="grid grid-cols-3 gap-2 mt-3">
                      <button
                        onClick={downloadQRCode}
                        title="Download QR Code"
                        className="flex flex-col items-center gap-1 py-2.5 bg-white border border-gray-200 rounded-lg text-slate-700 hover:border-brand-200 hover:text-brand-600 transition"
                      >
                        <Icons.Download className="w-4 h-4" />
                        <span className="text-[10px] font-medium">Download</span>
                      </button>
                      <button
                        onClick={handleCollabClick}
                        title="Collaborate"
                        className="flex flex-col items-center gap-1 py-2.5 bg-white border border-gray-200 rounded-lg text-slate-700 hover:border-brand-200 hover:text-brand-600 transition"
                      >
                        <Icons.Share className="w-4 h-4" />
                        <span className="text-[10px] font-medium">Share</span>
                      </button>
                      <button
                        onClick={copyLinkToClipboard}
                        title="Copy Link"
                        className="flex flex-col items-center gap-1 py-2.5 bg-white border border-gray-200 rounded-lg text-slate-700 hover:border-brand-200 hover:text-brand-600 transition"
                      >
                        {showCopied ? <Icons.Check className="w-4 h-4" /> : <Icons.Copy className="w-4 h-4" />}
                        <span className="text-[10px] font-medium">{showCopied ? 'Copied' : 'Copy link'}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </aside>

          {/* Main content */}
          <main className="lg:col-span-3">
            <div className="border-b border-gray-200 mb-5 flex items-center gap-8">
              <UnderlineTab active={activeTab === 'gallery'} onClick={() => setActiveTab('gallery')}>
                <span className="inline-flex items-center gap-2"><Icons.Image className="w-4 h-4" /> Gallery</span>
              </UnderlineTab>
              <UnderlineTab active={activeTab === 'people'} onClick={() => setActiveTab('people')}>
                <span className="inline-flex items-center gap-2"><Icons.Users className="w-4 h-4" /> People</span>
              </UnderlineTab>
              <UnderlineTab active={activeTab === 'flashbacks'} onClick={() => setActiveTab('flashbacks')}>
                <span className="inline-flex items-center gap-2"><Icons.Album className="w-4 h-4" /> Album</span>
              </UnderlineTab>
            </div>

            {/* Gallery tab */}
            {activeTab === 'gallery' && (
              <div className="space-y-4">
                {/* Header row */}
                <div className="flex items-center justify-between">
                  <div className="text-sm text-slate-500">
                    <span className="font-semibold text-slate-900">{(totalPhotoCount ?? images.length).toLocaleString()}</span> photos ·{' '}
                    <span className="font-semibold text-slate-900">
                      {images.filter(i => i.isFavourites).length}
                    </span>{' '}favourited
                  </div>
                  <div className="flex items-center gap-2">
                    <Button variant="secondary" icon={Icons.Upload} onClick={openUploadFilesModal}>
                      Upload images
                    </Button>
                  </div>
                </div>

                {/* Uniform grid — fixed-aspect cells keep everything aligned */}
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
                  {/* Upload tile */}
                  <div
                    onClick={openUploadFilesModal}
                    className="rounded-xl border-2 border-dashed border-gray-300 hover:border-brand-500 hover:bg-brand-50/30 transition aspect-[4/3] grid place-items-center text-slate-500 cursor-pointer"
                  >
                    <div className="text-center">
                      <Icons.Upload className="w-6 h-6 mx-auto text-brand-600" />
                      <div className="text-xs font-semibold mt-2">Upload images</div>
                      <div className="text-[11px] text-slate-400">Drag and drop or click</div>
                    </div>
                  </div>

                  {/* Skeleton cards — same size as photo cards while first load is in progress */}
                  {isGalleryLoading &&
                    images.length === 0 &&
                    Array.from({ length: 11 }).map((_, i) => (
                      <div
                        key={`sk-${i}`}
                        className="rounded-xl bg-gray-200 border border-gray-200 overflow-hidden animate-pulse aspect-[4/3]"
                      />
                    ))}

                  {/* Real photo cards */}
                  {images.map((imageData, index) => (
                    <PhotoCard
                      key={index}
                      imageData={imageData}
                      index={index}
                      onImageClick={handleImageClick}
                      onToggleFav={toggleFavourite}
                    />
                  ))}

                  {/* Inline skeletons while loading the next page */}
                  {isGalleryLoading &&
                    images.length > 0 &&
                    Array.from({ length: 4 }).map((_, i) => (
                      <div
                        key={`sk-more-${i}`}
                        className="rounded-xl bg-gray-200 border border-gray-200 overflow-hidden animate-pulse aspect-[4/3]"
                      />
                    ))}
                </div>

                <div ref={loader} style={{ height: '20px' }} />
              </div>
            )}

            {/* People tab */}
            {activeTab === 'people' && (
              <div className="space-y-5">
                {isPeopleLoading ? (
                  <div className="py-20 grid place-items-center">
                    <LoadingSpinner color="#2563eb" />
                  </div>
                ) : userThumbnails.length === 0 ? (
                  <div className="bg-white border border-gray-200 rounded-xl p-10 text-center text-slate-500">
                    No people detected in the photos you've uploaded. Try uploading more photos that contain human faces.
                  </div>
                ) : (
                  <>
                    {/* Summary card */}
                    <div className="bg-white border border-gray-200 rounded-xl p-5">
                      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                        <div className="flex items-center gap-6">
                          <div>
                            <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">Total Attendees</div>
                            <div className="text-3xl font-bold text-slate-900 mt-0.5">{userThumbnails.length}</div>
                          </div>
                          <div className="h-10 w-px bg-gray-200 hidden md:block" />
                          <div>
                            <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">Registrations</div>
                            <div className={`text-3xl font-bold text-brand-600 mt-0.5 transition-opacity ${isCountLoading ? 'opacity-50 animate-pulse' : ''}`}>
                              {registrationCount}
                            </div>
                          </div>
                          <div className="h-10 w-px bg-gray-200 hidden md:block" />
                          <div>
                            <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">Unregistered Faces</div>
                            <div className="text-3xl font-bold text-slate-900 mt-0.5">{unregisteredUsers.length}</div>
                          </div>
                        </div>
                        <div className="flex items-center gap-2">
                          {!mergeMode ? (
                            <Button variant="secondary" icon={Icons.User} onClick={handleMergeClick}>Manage Faces</Button>
                          ) : (
                            <Button variant="secondary" icon={Icons.X} onClick={handleCancelManageUsers}>Cancel</Button>
                          )}
                          <Button icon={Icons.Send} onClick={handleSendPhotos} disabled={isSending}>
                            {isSending ? "Sending..." : "Send Photos"}
                          </Button>
                        </div>
                      </div>
                    </div>

                    {/* People sub-tabs */}
                    <div className="flex items-center gap-2">
                      <Pill active={userCategoryTab === 'registered'} onClick={() => setUserCategoryTab('registered')}>
                        Registered Users
                      </Pill>
                      <Pill active={userCategoryTab === 'unregistered'} onClick={() => setUserCategoryTab('unregistered')}>
                        Unregistered Users
                      </Pill>
                    </div>

                    {mergeMessage && (
                      <div className="text-sm text-brand-600 font-medium">{mergeMessage}</div>
                    )}
                    {!isImageProcessingDone && (
                      <div className="text-sm text-amber-600 bg-amber-50 border border-amber-100 rounded-lg px-3 py-2">
                        Some of the images are still being processed. Stay tuned for updates.
                      </div>
                    )}
                    {mergeMode && (
                      <div className="text-sm text-slate-700 bg-brand-50 border border-brand-100 rounded-lg px-3 py-2">
                        Select 2 duplicate faces to merge
                      </div>
                    )}

                    {/* Registered users grid */}
                    {userCategoryTab === 'registered' && (
                      <div className="bg-white border border-gray-200 rounded-xl p-5">
                        {isImageProcessingDone && registeredUsers.length === 0 ? (
                          <div className="text-center text-slate-700 py-8 font-bold">
                            No registered users, please check unregistered user's tab.
                          </div>
                        ) : (
                          <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-3">
                            {registeredUsers.map((item, index) => {
                              const isSelected = selectedUsers.some((u) => u.user_id === item.user_id);
                              return (
                                <div
                                  key={index}
                                  onClick={() => handleClick(item)}
                                  className={`relative aspect-square rounded-lg overflow-hidden border bg-gray-50 cursor-pointer transition ${mergeMode ? 'hover:scale-[1.03]' : ''} ${isSelected ? 'border-brand-500 ring-2 ring-brand-500/40' : 'border-gray-200'}`}
                                >
                                  <LazyLoadImage src={item.face_url} alt={`User ${index + 1}`} className="w-full h-full object-cover" />
                                  <div className="absolute bottom-0 left-0 right-0 bg-slate-900/85 text-white text-[10px] font-mono text-center py-1 px-1 flex flex-col items-center">
                                    <span>{item.count}</span>
                                    <span className="truncate w-full">{item.user_phone_number}</span>
                                  </div>
                                  {mergeMode && isSelected && (
                                    <div className="absolute top-1.5 right-1.5 w-5 h-5 grid place-items-center bg-brand-600 text-white rounded-full text-xs font-bold">✓</div>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    )}

                    {/* Unregistered users grid */}
                    {userCategoryTab === 'unregistered' && (
                      <div className="bg-white border border-gray-200 rounded-xl p-5">
                        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-3">
                          {unregisteredUsers.map((item, index) => {
                            const isSelected = selectedUsers.some((u) => u.user_id === item.user_id);
                            return (
                              <div
                                key={index}
                                onClick={() => handleClick(item)}
                                className={`relative aspect-square rounded-lg overflow-hidden border bg-gray-50 cursor-pointer transition ${mergeMode ? 'hover:scale-[1.03]' : ''} ${isSelected ? 'border-brand-500 ring-2 ring-brand-500/40' : 'border-gray-200'}`}
                              >
                                <LazyLoadImage src={item.face_url} alt={`User ${index + 1}`} className="w-full h-full object-cover" />
                                <div className="absolute bottom-0 left-0 right-0 bg-slate-900/85 text-white text-[10px] font-mono text-center py-1 px-1">
                                  {item.count}
                                </div>
                                {mergeMode && isSelected && (
                                  <div className="absolute top-1.5 right-1.5 w-5 h-5 grid place-items-center bg-brand-600 text-white rounded-full text-xs font-bold">✓</div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            )}

            {/* Album tab */}
            {activeTab === 'flashbacks' && (
              <div className="space-y-5">
                <div className="bg-white border border-gray-200 rounded-xl p-5">
                  <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                    <div className="flex items-center gap-4">
                      <div className="w-12 h-12 rounded-xl bg-rose-50 border border-rose-100 text-rose-600 grid place-items-center shrink-0">
                        <Icons.Heart className="w-6 h-6" />
                      </div>
                      <div>
                        <h3 className="font-bold text-slate-900">Favourites</h3>
                        <p className="text-sm text-slate-500 mt-1">
                          <span className="font-semibold text-slate-900">{favouriteImages.length}</span>{' '}
                          photo{favouriteImages.length === 1 ? '' : 's'} marked with a heart
                        </p>
                      </div>
                    </div>
                    <Button
                      variant="secondary"
                      icon={Icons.Download}
                      onClick={downloadEventAlbum}
                      disabled={isDownloadingAlbum}
                      className="w-full md:w-auto"
                    >
                      {isDownloadingAlbum ? 'Starting...' : 'Download Album'}
                    </Button>
                  </div>
                </div>

                {isGalleryLoading && favouriteImages.length === 0 ? (
                  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
                    {Array.from({ length: 8 }).map((_, index) => (
                      <div
                        key={`album-fav-skeleton-${index}`}
                        className="rounded-xl bg-gray-200 border border-gray-200 overflow-hidden animate-pulse aspect-[4/3]"
                      />
                    ))}
                  </div>
                ) : favouriteImages.length > 0 ? (
                  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
                    {favouriteImages.map((imageData, index) => (
                      <PhotoCard
                        key={imageData.original}
                        imageData={imageData}
                        index={index}
                        onImageClick={(selectedImage, selectedIndex) =>
                          handleImageClick(selectedImage, selectedIndex, favouriteImages)
                        }
                        onToggleFav={() => handleFavourite(index, imageData.original, false)}
                      />
                    ))}
                  </div>
                ) : (
                  <div className="bg-white border border-gray-200 rounded-xl p-10 text-center">
                    <div className="mx-auto w-12 h-12 rounded-xl bg-rose-50 border border-rose-100 text-rose-600 grid place-items-center">
                      <Icons.Heart className="w-6 h-6" />
                    </div>
                    <h3 className="mt-4 font-bold text-slate-900">No favourites yet</h3>
                    <p className="text-sm text-slate-500 mt-1">
                      Heart photos from the Gallery and they will appear here in the Album section.
                    </p>
                    <Button
                      type="button"
                      variant="secondary"
                      className="mt-5"
                      icon={Icons.Image}
                      onClick={() => setActiveTab('gallery')}
                    >
                      Back to Gallery
                    </Button>
                  </div>
                )}
              </div>
            )}
          </main>
        </div>
      </div>

      <Footer />

      {/* Image viewer modal */}
      {clickedImg && (
        <div className="fixed top-0 right-0 bottom-0 w-full md:w-1/2 bg-black z-[1000] flex items-center justify-center">
          <ImageModal
            clickedImg={clickedImg}
            clickedImgIndex={clickedImgIndex}
            clickedImgFavourite={clickedImgFavourite}
            setClickedImg={setClickedImg}
            clickedUrl={clickedUrl}
            handleBackButton={handleBackButton}
            images={viewerImages}
            handleFavourite={handleFavourite}
          />
        </div>
      )}

      {/* Upload files modal */}
      <ModalShell open={isUploadFilesModelOpen} onClose={closeUploadFilesModal} maxWidth="max-w-lg">
        <div className="flex items-start justify-between p-6 border-b border-gray-100">
          <h2 className="text-lg font-bold text-slate-900">Upload Files</h2>
          {!uploading && (
            <button
              onClick={closeUploadFilesModal}
              className="w-9 h-9 grid place-items-center rounded-lg text-slate-500 hover:bg-gray-100"
              aria-label="Close"
            >
              <Icons.X className="w-4 h-4" />
            </button>
          )}
        </div>
        <div className="p-6 space-y-4">
          <div
            {...getRootProps()}
            className={`flex flex-col items-center justify-center gap-2 w-full rounded-xl border-2 border-dashed px-6 py-10 cursor-pointer transition ${isDragActive ? 'border-brand-500 bg-brand-50/40' : 'border-gray-300 bg-gray-50 hover:border-brand-400 hover:bg-brand-50/20'}`}
          >
            <input {...getInputProps()} />
            <Icons.Upload className="w-6 h-6 text-brand-600" />
            <p className="text-sm text-slate-600 text-center">Drag 'n' drop files here, or click to select files</p>
          </div>
          {files.length > 0 && (
            <p className="text-sm text-slate-600">{fileCount} file(s) selected.</p>
          )}
          {uploadStatus && <p className="text-sm text-slate-600">{uploadStatus}</p>}
          <div className="flex justify-center pt-1">
            <Button onClick={uploadFiles} disabled={files.length === 0 || fileCount > 500}>
              {uploading ? "Uploading..." : "Upload"}
            </Button>
          </div>
          {uploading && (
            <div className="w-full h-2.5 bg-gray-100 rounded-full overflow-hidden">
              <div
                className="h-full bg-brand-600 transition-all duration-300"
                style={{ width: `${overallProgress}%` }}
              />
            </div>
          )}
        </div>
      </ModalShell>

      {/* Collaboration modal */}
      <ModalShell open={isCollabModalOpen} onClose={() => setIsCollabModalOpen(false)} maxWidth="max-w-lg">
        <ModalHeader
          title="Collaborate on Event"
          subtitle="Share this QR code or link to invite others to collaborate"
          onClose={() => setIsCollabModalOpen(false)}
        />
        <div className="p-6 space-y-5">
          <div className="flex flex-col items-center gap-4">
            <div id="collab-qr-canvas" className="bg-gray-50 border border-gray-200 rounded-xl p-4 grid place-items-center">
              <QRCodeSVG value={collabLink} size={180} />
            </div>
            <div className="w-full bg-gray-50 border border-gray-200 rounded-lg px-3 py-2 text-xs font-mono text-slate-600 truncate text-center">
              {collabLink}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <Button variant="secondary" icon={Icons.Download} onClick={downloadCollabQRCode}>
              Download QR
            </Button>
            <Button variant="secondary" icon={Icons.Copy} onClick={copyCollabLinkToClipboard}>
              Copy Link
            </Button>
            <button
              onClick={shareCollabOnWhatsApp}
              className="col-span-2 inline-flex items-center justify-center gap-2 font-medium text-sm px-4 py-2.5 rounded-lg text-white transition"
              style={{ backgroundColor: '#25D366' }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#1fa851')}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#25D366')}
            >
              <Icons.Share className="w-4 h-4" />
              Share on WhatsApp
            </button>
          </div>

          <p className="text-center text-xs text-slate-500 leading-relaxed">
            Collaborators can scan this QR code or use the link to join your event and help with photo management.
          </p>
        </div>
      </ModalShell>

      {/* Merge duplicate users popup */}
      {showMergePopup && (
        <MergeDuplicateUsers
          users={selectedUsers}
          onClose={handleCancelManageUsers}
          isOpen={showMergePopup}
          onMerge={handleMerge}
        />
      )}

      {/* Send photos modal */}
      <ModalShell open={isSendModalOpen} onClose={() => setIsSendModalOpen(false)} maxWidth="max-w-lg">
        <ModalHeader title="Send Photos" onClose={() => setIsSendModalOpen(false)} />
        <div className="p-6 space-y-2 text-sm text-slate-600">
          <p>Only registered users will receive Photos.</p>
          <p>For unregistered users, you can click on their thumbnail and send photos through your WhatsApp.</p>
        </div>
      </ModalShell>

      {/* Warning modal (images still processing) */}
      <ModalShell open={isWarningModalOpen} onClose={closeWarningModal} maxWidth="max-w-md">
        <ModalHeader title="Please wait" onClose={closeWarningModal} />
        <div className="p-6 space-y-4 text-sm text-slate-600">
          <p>Some of the images are still being processed. Please wait until processing is complete before proceeding.</p>
          <div className="flex justify-end">
            <Button onClick={closeWarningModal}>Got it</Button>
          </div>
        </div>
      </ModalShell>

      {/* Edit event modal */}
      <ModalShell open={editMode} onClose={handleCancelEdit} maxWidth="max-w-lg">
        <ModalHeader title="Edit Event" onClose={handleCancelEdit} />
        <div className="p-6">
          <form onSubmit={handleFormSubmit} className="space-y-4">
            <LabelAndInput
              label="Event Name"
              name="eventName"
              value={eventData.eventName}
              handleChange={handleInputChange}
              isEditable={true}
            />
            <LabelAndInput
              label="Event Date"
              name="eventDate"
              type="date"
              value={eventData.eventDate}
              handleChange={handleInputChange}
              isEditable={true}
            />
            <LabelAndInput
              label="Event Time"
              name="eventTime"
              type="time"
              value={eventData.eventTime}
              handleChange={handleInputChange}
              isEditable={true}
            />
            <LabelAndInput
              label="Invitation Note"
              name="invitationNote"
              value={eventData.invitationNote}
              handleChange={handleInputChange}
              isEditable={true}
            />
            <LabelAndInput
              label="Event Location"
              name="eventLocation"
              value={eventData.eventLocation}
              handleChange={handleInputChange}
              isEditable={true}
            />

            <div>
              <label htmlFor="eventImage" className="block text-xs font-semibold text-slate-700 mb-1.5">Upload Banner Image</label>
              <input
                type="file"
                id="eventImage"
                name="eventImage"
                accept="image/*"
                onChange={handleEventImageUpdate}
                className="w-full text-sm text-slate-600 file:mr-3 file:py-2 file:px-3 file:rounded-lg file:border file:border-gray-200 file:bg-white file:text-slate-700 file:text-sm hover:file:bg-gray-50"
              />
            </div>

            <div>
              <label htmlFor="watermarkImage" className="block text-xs font-semibold text-slate-700 mb-1.5">Update Watermark (Optional)</label>
              <input
                type="file"
                id="watermarkImage"
                name="watermarkImage"
                accept="image/*"
                onChange={handleWatermarkChange}
                className="w-full text-sm text-slate-600 file:mr-3 file:py-2 file:px-3 file:rounded-lg file:border file:border-gray-200 file:bg-white file:text-slate-700 file:text-sm hover:file:bg-gray-50"
              />

              {/* Show current watermark if exists */}
              {currentWatermark && !watermarkPreview && (
                <div className="mt-3 p-3 border border-gray-200 rounded-lg bg-white">
                  <div className="flex items-center gap-2 mb-2 text-sm text-slate-500">
                    <span className="text-green-600">✓</span>
                    Current Watermark:
                    <button
                      type="button"
                      onClick={removeWatermark}
                      className="ml-auto text-xs px-2 py-1 rounded-md bg-white text-red-600 border border-red-100 hover:bg-red-50"
                    >
                      Remove
                    </button>
                  </div>
                  <img src={currentWatermark} alt="Current watermark" className="max-w-[150px] max-h-[75px] object-contain rounded shadow" />
                </div>
              )}

              {/* Show new watermark preview */}
              {watermarkPreview && (
                <div className="mt-3 p-3 border border-gray-200 rounded-lg bg-white">
                  <div className="flex items-center gap-2 mb-2 text-sm text-slate-500">
                    <span>📝</span>
                    New Watermark Preview:
                  </div>
                  <img src={watermarkPreview} alt="New watermark preview" className="max-w-[150px] max-h-[75px] object-contain rounded shadow" />
                </div>
              )}

              {/* Show status if no watermark */}
              {!currentWatermark && !watermarkPreview && (
                <div className="mt-3 p-3 border border-gray-200 rounded-lg bg-white">
                  <div className="flex items-center gap-2 text-sm text-slate-500">
                    <span>❌</span>
                    No watermark currently set
                  </div>
                </div>
              )}
            </div>

            <div className="pt-2">
              <Button type="submit">Save</Button>
            </div>
          </form>
        </div>
      </ModalShell>
    </div>
  );
};

export default EventDetails;
